import { render, staticRenderFns } from "./CalculationTable.vue?vue&type=template&id=2f274635"
import script from "./CalculationTable.vue?vue&type=script&lang=js"
export * from "./CalculationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports